import { HttpContextToken } from '@angular/common/http';

export enum TOKEN_USE {
	NONE = 1,
	OCM = 2,
	DX = 3,
	BOTH = 4,
}
export const TOKEN_SCHEME = new HttpContextToken<TOKEN_USE>(() => TOKEN_USE.OCM);
